import { createFileRoute } from '@tanstack/react-router';

import { EmailTemplatesPage } from '@/areas/quote-requests/EmailTemplates/EmailTemplatesPage';
import { canViewInternalOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/templates/_sidebar/email/')({
    staticData: {
        access: { permissions: canViewInternalOrganizationSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <EmailTemplatesPage />;
}
